export function Header() {
  return (
    <header className={'border-b border-gray-500 p-2'}>
      <h1 className={'text-3xl'}>zalktis</h1>
    </header>
  )
}
